// extracted by mini-css-extract-plugin
module.exports = {"sideNavigation":"styles_sideNavigation__mG1Cj"};